import { Card, Col, Row } from "antd";
import { useState } from "react";

import { hardRedirect } from "../../lib/redirect";
import routes from "../../lib/routes";
import { Space } from "../shared/Space";
import { Localities } from "./Localities";
import Welcome from "./Welcome";

const finish = () => {
  hardRedirect(routes.onboarding + "?pillars=true");
};

export default function Onboarding() {
  const [currentStep, setCurrentStep] = useState("welcome");

  const onNextStep = (step: string) => () => {
    setCurrentStep(step);
    window.scrollTo(0, 0);
  };

  if (currentStep == "welcome") {
    return <Welcome onNextClick={onNextStep("companySettings")} />;
  }

  return (
    <Row justify="center" align="middle">
      <Col xs={24} md={16}>
        <Card>
          <Space vertical size="large">
            <Localities onNextClick={finish} />
          </Space>
        </Card>
      </Col>
    </Row>
  );
}
